// extracted by mini-css-extract-plugin
export default {"taskBtn":"AddTaskBtn_taskBtn__8hWaH","iconPlus":"AddTaskBtn_iconPlus__FaWYN"};